import { Wrench } from 'lucide-react'
import {
  pickString,
  readToolState,
  ToolStatusLine,
  type ToolPartProps,
} from './_base'

export function LoadSkillToolMessage({ part }: ToolPartProps) {
  const state = readToolState(part)
  return (
    <ToolStatusLine
      state={state}
      loadingLabel='Loading skill...'
      completedLabel='Skill activated'
      completedIcon={
        <Wrench className='h-3.5 w-3.5 shrink-0 text-text-placeholder' />
      }
      loadingDetail={pickString(state.args?.name)}
      completedDetail={pickString(state.args?.name)}
    />
  )
}
